/**
 * Created by saltrichter on 08/10/17.
 */

define(function (require) {

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        NotificationTabLayout = require("connection-views/layouts/notificationTab/NotificationTabLayout"),
        NotificationListView = require("connection-views/notificationTab/NotificationListView"),
        NotificationCollection = require("connection-collections/notificationTab/NotificationCollection"),
        NotificationViewController = require("connection-controllers/notificationTab/NotificationViewController"),
        NotificationTabController = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        NotificationTabController = Marionette.Controller.extend({

            initialize: function (options) {

                logger.debug("initialize : entered", "NotificationTabController.initialize");

                this._chatChannel = options.chatChannel;
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this._initializeChannels();
                this._initNotificationTabCollection();
                if(this.connectionPanelContextModel.isNotificationCenterEnabled()){
                    this._initNotificationTabComponents();
                    this._showRegion(this.notificationTabLayout.notificationListRegion, this.notificationList);
                    this._bindEvents();
                    this._renderNotificationTabLayout();
                }
                this.locked = false;
            },

            _bindEvents: function () {
                this.listenTo(this.channel.vent,"NotificationTabController::notification:display",this._displayNotificationView);
                this.listenTo(this.channel.vent,"NotificationTabController::notification:remove",this._removeNotification);
                this.listenTo(this.channel.vent,"NotificationTabController::notificationView:close",this._closeNotificationView);
                this.listenTo(this.channel.vent,"NotificationTabController::track:usage",this._trackUsage);
                this.listenTo(this.connectionPanelContextModel, "change:selectedNotification", this._changeSelectedNotification);
                LEConnection.vent.once("NotificationTabController::noData:show", this._setNoData,this);
                LEConnection.vent.on('NotificationTabController:scrollTop', this._scrollTop, this);
            },

            _initializeChannels: function(){
                this.channel = LEConnection.media.channel(LE.mediaCodes.connection.channels.NOTIFICATION_TAB);
                this.contentContainerChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.CONTENT_CONTAINER);
                this.notificationViewControllerChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.NOTIFICATION_VIEW);
                this.usageTrackingChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.USAGE_TRACKING);
                LEConnection.logger.debug("NotificationTabController._initializeChannels: successfully initialized NotificationTab events channels");
            },

            _initNotificationTabCollection: function () {
                this.notifications = new NotificationCollection(null, {
                    channel: this.channel,
                    contextModel: this.connectionPanelContextModel,
                    visibility: this.visibility
                });
            },

            _initNotificationTabComponents: function () {
                this.notificationTabLayout = new NotificationTabLayout();
                this.NotificationViewController = new NotificationViewController({
                    connectionPanelContextModel: this.connectionPanelContextModel,
                    channel: this.channel,
                    containerChannel : this.contentContainerChannel,
                    notificationViewControllerChannel: this.notificationViewControllerChannel,
                    notificationsCollection: this.notifications
                });
                this.notificationList = new NotificationListView({
                    collection: this.notifications
                });
            },

            _renderNotificationTabLayout: function(){
                LEConnection.vent.trigger("MainContainerController::showRegion:notificationRegion", {
                    view: this.notificationTabLayout
                });
            },

            _removeNotification: function (model, fromExpanded) {
                var selectedNotification = this.connectionPanelContextModel.getSelectedNotification();
                if (fromExpanded || selectedNotification && selectedNotification.cid === model.cid) {
                    this._closeNotificationView();
                }
                model.markAsDeleted();
                this._trackUsage({
                    slug: model.getTrackingTitle(),
                    usageToTrack:CP_CONST.USAGE_TO_TRACK.MY_NOTIFICATIONS.REMOVE_ONE_NOTIFICATION
                });
            },

            _displayNotificationView: function (model) {
                this._setNotificationAsTopElement();
                var previousNotification = this._getSelectedNotification();
                var currentNotification = model || null;
                if(previousNotification && currentNotification && (previousNotification.getId() === currentNotification.getId())){
                    currentNotification = null;
                    this._closeNotificationView();
                }else{
                    if(!_.isNull(currentNotification)){
                        this._setSelectedNotification(currentNotification);
                        this.connectionPanelContextModel.setNotificationViewIsOpen(true);
                        this.notificationViewControllerChannel.vent.trigger("NotificationViewController::notification:display",model);
                        //USAGE TRACKING
                        this._trackUsage({
                            slug: currentNotification.getTrackingTitle(),
                            usageToTrack:CP_CONST.USAGE_TO_TRACK.MY_NOTIFICATIONS.OPEN_ONE_NOTIFICATION
                        });
                    }
                }
            },

            _changeSelectedNotification: function (model, selectedNotification) {
                if (this.notificationList) {
                    var id = (selectedNotification) ? selectedNotification.get("id") : "";
                    this.notificationList.setSelected(id);
                    this._setSelectedNotification(selectedNotification);
                }
            },

            _closeNotificationView: function(){
                this._closeContentContainer();
                this._setSelectedNotification(null);
            },

            _setSelectedNotification: function(notification){
                this.connectionPanelContextModel.setSelectedNotification(notification);
            },

            _getSelectedNotification: function(){
                return this.connectionPanelContextModel.getSelectedNotification();
            },

            _setNotificationAsTopElement: function () {
                this.connectionPanelContextModel.setTopElement(CP_CONST.PAGE.NOTIFICATION);
            },

            _closeContentContainer: function(){
                this.contentContainerChannel.vent.trigger("NotificationExtendedContainerController::container:close");
            },

            _setNoData:function(){
                this.notificationTabLayout.setNoData();
            },

            _scrollTop:function(){
                this.notificationTabLayout.scrollTop();
            },
            _trackUsage: function(options){
                this.usageTrackingChannel.vent.trigger("UsageTrackingController:track",options);
            },

            _showRegion: function (region, view) { //??
                if (this.notificationTabLayout.getIsRendered()) {
                    region.show(view);
                }
                else {
                    this.listenTo(this.notificationTabLayout, "render", function () {
                        region.show(view);
                    });
                }
            }
        });
    });

    return NotificationTabController;
});
